import React from "react";

const jobs = [
  {
    id: 1,
    title: "Telecaller",
    location: "Ahilyanagar | Shevgaon",
    type: "Full Time | Part Time",
    link: "",
    skills: [
      "Good communication",
      "Basic Computer knowledge",
      "Basic Programmig Skill",
    ],
  },
  {
    id: 2,
    title: "Office Assistant",
    location: "Ahilyanagar | Shevgaon",
    type: "Full Time",
    link: "",
    skills: [
      "Proficient in MS Office (Word, Excel, PowerPoint) and basic computer operations.",
      "Strong organizational and time management skills.",
      "Ability to handle administrative tasks and office coordination efficiently.”",
      "Skilled in managing records, documentation, and scheduling tasks.",
    ],
  },
  {
    id: 3,
    title: "PHP Developer - MVC / Yii",
    location: "Pune",
    type: "Full Time",
    link: "",
    skills: [
      "1+ year experience in PHP/MySQL",
      "MVC architecture knowledge",
      "Good communication",
      "Strong logic",
    ],
  },
  {
    id: 4,
    title: "Android Developer (1-3 Yrs)",
    location: "Pune",
    type: "Full Time",
    link: "",
    skills: [
      "Core Java & Android SDK",
      "API, XML, JSON",
      "REST services knowledge",
    ],
  },
  {
    id: 5,
    title: "Java Developer And Trainer",
    location: "Ahilyanagar",
    type: "Full Time",
    link: "",
    skills: [
      "Core Java",
      "Spring, Hibernate",
      "REST & SOAP",
    ],
  },

  {
    id: 6,
    title: "Data Science & Gen AI Developer",
    location: "Ahilyanagar",
    type: "Full Time",
    link: "",
    skills: [
      "Proficient in Python, data analysis, and machine learning algorithms",
      "Strong knowledge of data preprocessing, visualization, and statistical analysis.",
      "Skilled in working with frameworks like TensorFlow, PyTorch, and NLP techniques.",
      "Ability to solve real-world problems using AI-driven and data-centric approaches.",
    ],
  },
  
];

function Careers() {
  return (
    <>
    <div className="container-fluid text-center text-white p-5 career-header">
                    <div class="row p-4">
                        <div class="col-12 ">
                            <div className="entry-banner">
        <div className="container">
          <h1 className="entry-title">Careers</h1>
          <h5 style={{'color':'white-smoke'}}>“Join our team and build a rewarding career in a dynamic and innovative IT environment.”</h5>
        </div>
      </div>

                        </div>
                       
                    </div>
    </div>
    <div className="careers">
     
     

      {/* Banner */}
      <div className="entry-banner">
        <div className="container">
          <h1 className="entry-title"></h1>
        </div>
      </div>

      {/* Intro */}
      <div className="container text-center">
        <h3>🌟 Join the Team! 🌟</h3>
        <p>We are looking for talented developers (0-5 years experience).</p>

        <p>
          📧 Send resume:
          <a href=""> hr@lthitsolutions.com</a>
        </p>

        <p>📞 Contact: +91-975260001</p>
      </div>

      {/* Jobs */}
      <div className="container mt-4">
        {jobs.map((job) => (
          <div key={job.id} className="apply-item mb-4 p-3 border">

            <h3>{job.title}</h3>

            <ul>
              {job.skills.map((skill, index) => (
                <li key={index}>{skill}</li>
              ))}
            </ul>

            <p>
              <strong>Location:</strong> {job.location} |{" "}
              <strong>Type:</strong> {job.type}
            </p>

            <a
              href={job.link}
              target="_blank"
              rel="noreferrer"
              className="btn"
            >
              Apply Now
            </a>

          </div>
        ))}
      </div>

    </div>
    </>
  );
}

export default Careers;